import {
    NinchatActionType,
    NinchatUpdateDialogueAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const updateDialogue = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateDialogueAction}`,
    async (arg: NinchatActionParams<NinchatUpdateDialogueAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatUpdateDialogueAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
